import { Navigate } from "react-router";
import { useGetTimberTypeQuery } from "../../../apis/TimberType.api";
import { PrimaryTimberType, TimberType } from "../../../types/models/TimberType";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const TimberTypeScoped = () => {
    const {
        data,
    } = useGetTimberTypeQuery(PrimaryTimberType.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/timber-types/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default TimberTypeScoped;
